import React, { useState, useEffect } from "react";
import "./SignupPage.css";
import {
  Row,
  Container,
  Form,
  InputGroup,
  FormControl,
  Spinner,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import OtpPage from "../../otpverification/components/OtpPage";
import { toast } from "react-toastify";
import { fetchLogindata } from "../../login/redux/actions";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { findAccountdeletedrequest } from "../../login/util/findAccountIfDeleted";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import "react-phone-input-2/lib/style.css";
import startsWith from "lodash.startswith";
import { EYE, EYE_OFF } from "../../comman/components/CommonimagePath";
import { sendOtprequest } from "../../otpverification/util/sendOtp";
import PhoneInputPage from "../../comman/phoneinput/PhoneInputPage";
import FormgroupPage from "../../comman/formgroup/FormgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";
import { maintainCartdata } from "../../home/redux/actions";

function SignupPage(props) {
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  const registerInput = {
    fullname: "",
    mobile:
      location?.state?.fromlogin === true ? location?.state?.mobilenum : "",
    email: "",
    password: "",
    country_code:
      location?.state?.fromlogin === true
        ? location?.state?.country_code
        : "90",
    country_isocode: location?.state?.fromlogin === true ? "" : "tr",
  };
  const errorParameter = {
    fullname: "",
    mobile: "",
    email: "",
    password: "",
    country_code: "",
  };
  const emailRegex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  const passRegex =
    /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\w\W]){1,})(?!.*\s).{8,}$/;
  // const nameRegex = /^[A-Za-z ığüşöçİĞÜŞÖÇ]+$/;
  const [inputvalue, setInputvalue] = useState(registerInput);
  const [errorMsg, setErrormsg] = useState(errorParameter);
  const [showotp, setShowotp] = useState(false);
  const [page_from, setpage_from] = useState("signup");
  const [phoneinput, setPhoneinput] = useState("");
  const [passwordState, setPasswordState] = useState(false);
  const [mobileexist, setMobileexist] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => showSignuppopup())();
    // eslint-disable-next-line
  }, [props?.language]);

  const showSignuppopup = () => {
    if (location?.state?.fromlogin === true) {
      toast.error(t("pages.signup.No accound found please sign up"));
      setPhoneinput(location?.state?.country_code + location?.state?.mobilenum);
    }
    props?.fetchHeaderContent(t("pages.meta.signup.title"), t("pages.meta.signup.description"), "");
  };

  const validation = () => {
    let checkValue = "";
    // if (!nameRegex.test(inputvalue.fullname)) {
    //   errorMsg.fullname = "pages.signup.fullname_validation";
    //   checkValue = "false";
    // }
    if (inputvalue.fullname === "") {
      errorMsg.fullname = "pages.signup.fullname_warn";
      checkValue = "false";
    }
    if (!emailRegex.test(inputvalue.email)) {
      errorMsg.email = "pages.profile.email_address_valid";
      checkValue = "false";
    }
    if (inputvalue.email === "") {
      errorMsg.email = "pages.signup.email_warn";
      checkValue = "false";
    }
    if (inputvalue.mobile === "") {
      errorMsg.mobile = "pages.signup.mobile_warn";
      checkValue = "false";
    }
    if (errorMsg.country_code !== "") {
      errorMsg.mobile = "";
      checkValue = "false";
    }
    if (!passRegex.test(inputvalue.password)) {
      errorMsg.password = "pages.signup.password_valid";
      checkValue = "false";
    }
    if (inputvalue.password === "") {
      errorMsg.password = "pages.signup.password_warn";
      checkValue = "false";
    }
    setErrormsg({
      ...errorMsg,
      fullname: errorMsg.fullname,
      email: errorMsg.email,
      password: errorMsg.password,
      mobile: errorMsg.mobile,
    });
    if (checkValue === "false") {
      return false;
    } else {
      return true;
    }
  };

  const inputValuechange = (e) => {
    setInputvalue({
      ...inputvalue,
      [e.target.name]: e.target.value,
    });

    switch (e.target.name) {
      case "fullname":
        setErrormsg({
          ...errorMsg,
          fullname: "",
        });
        break;
      case "mobile":
        setErrormsg({
          ...errorMsg,
          mobile: "",
        });
        break;
      case "email":
        setErrormsg({
          ...errorMsg,
          email: "",
        });
        break;
      case "password":
        setErrormsg({
          ...errorMsg,
          password: "",
        });
        break;
      default:
        break;
    }
  };

  const onSignUp = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoader(true);
      let findAccountdeletedresponse = await findAccountdeletedrequest(
        inputvalue.mobile,
        inputvalue.country_code
      );
      if (findAccountdeletedresponse?.status === 200) {
        toast.error(t("pages.Your account deleted please contact to admin"));
      } else if (findAccountdeletedresponse?.status === 404) {
        // if (location?.state?.fromlogin === true) {
        //   forSignup();
        // } else {
          let sendOtpresponse = await sendOtprequest(
            inputvalue.mobile,
            inputvalue.country_code,
            props?.language?.toLowerCase()
          );
          if (
            sendOtpresponse?.status === 200 ||
            sendOtpresponse?.status === 201
          ) {
            let result = await sendOtpresponse.json();
            if (result?.data?.mobile_already_exist === "yes") {
              setMobileexist(true);
            } else {
              setMobileexist(false);
            }
            setShowotp(true);
          } else if (sendOtpresponse?.status === 400) {
            let responce = await sendOtpresponse.json();
            toast.error(responce?.errors);
            setShowotp(false);
          }
        // }
      }
      setLoader(false);
    }
  };

  const redirectTologin = () => {
    navigate("/login");
  };

  // const forSignup = async () => {
 
  //   let registerInput = {
  //     fullname: inputvalue.fullname,
  //     mobile: inputvalue.mobile,
  //     email: inputvalue.email,
  //     password: inputvalue.password,
  //     type: "user",
  //     lang: props?.language?.toLowerCase(),
  //     lat: props?.currentLocation?.lat,
  //     lng: props?.currentLocation?.lng,
  //     address: props?.currentLocation?.address,
  //     zip_code: props?.currentLocation?.zip_code,
  //     country_code: inputvalue.country_code,
  //   };
  //   let registerResponse = await registerrequest(registerInput);
  //   if (registerResponse?.status === 200) {
  //     let loginData = await registerResponse.json();
  //     let getIp = await getIpaddress();
  //     props.fetchLogindata(loginData.data, getIp?.ip);
  //     updateCart(loginData);
  //   } else if (registerResponse.status === 500) {
  //     toast.error(t("pages.signup.email_exist"));
  //   } else if (registerResponse.status === 400) {
  //     let getValue = await registerResponse.json();
  //     showServererror(getValue);
  //   }
  // };

  // const showServererror = (getValue) => {
  //   if (getValue?.errors?.mobile && getValue?.errors?.email) {
  //     toast.error(
  //       t(
  //         "pages.Your mobile and email already been taken please sign up with another email and mobile"
  //       )
  //     );
  //   } else if (getValue?.errors?.mobile) {
  //     toast.error(t("pages.please sign up with another mobile"));
  //   } else if (getValue?.errors?.email) {
  //     toast.error(t("pages.please sign up with another email"));
  //   }
  // };

  // const updateCart = async (loginData) => {
  //   if(props?.cartdata?.length > 0) {
  //     let object = {};
  //     let productlist = [];
  //     props?.cartdata?.forEach((product) => {
  //       object = {
  //         store_id: product?.store_id,
  //         product_id: product?.product_id,
  //         variation_id: product?.variation_id,
  //         quantity: product?.quantity,
  //         id: product?.id,
  //       };
  //       productlist.push(object);
  //     });
  //     let data = {
  //       cartdata: productlist,
  //     };
  //     const updateCartresponse = await updateCartrequest(
  //       loginData?.data?.token?.access_token,
  //       data,
  //       props?.language?.toLowerCase()
  //     );
  //     if (updateCartresponse?.status === 200) {
  //       navigate("/");
  //     } else if(updateCartresponse.status === 400) {
  //       let getErrormsg = await updateCartresponse.json();
  //       toast.error(getErrormsg?.errors);
  //       props.maintainCartdata([], {});
  //       navigate("/");
  //     }
  //   }else{
  //     navigate("/");
  //   }
  // };

  const countryChange = (value, data) => {
    if (value !== "") {
      let getValue =
        startsWith(value, data?.dialCode) || startsWith(data?.dialCode, value);
      if (getValue === false) {
        setErrormsg({
          ...errorMsg,
          mobile: "",
          country_code: "pages.login.country_code_valid",
        });
      } else {
        setErrormsg({
          ...errorMsg,
          mobile: "",
          country_code: "",
        });
      }
      setPhoneinput(value);
      let phonecode = { rawPhone: value.slice(data.dialCode.length) };
      setInputvalue({
        ...inputvalue,
        mobile: phonecode?.rawPhone?.toString(),
        country_code: data?.dialCode.toString(),
        country_isocode: data?.countryCode,
      });
    } else {
    }
  };

  return (
    <>
      <section className="signup-section common_login-section">
        <div className="signup-container ">
          <Container>
            <Row className="justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-10 col-xl-10">
                <div className="signup-box common_box">
                  <Row>
                    <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                      {showotp === false ? (
                        <Form className="signup-form">
                          <div className="form-header">
                            <h2>{t("pages.signup.title")}</h2>
                          </div>
                          <div className="form-content">
                              <FormgroupPage
                                className="form-group"
                                label={''}
                                placeholder={t("pages.signup.fullname_place")}
                                name={"fullname"}
                                value={
                                  inputvalue.fullname.charAt(0).toUpperCase() +
                                  inputvalue.fullname.slice(1)
                                }
                                onChange={(e) => inputValuechange(e)}
                                type="text"
                                error={t(errorMsg.fullname)}
                                require={false}
                              />
                            <div>
                              <PhoneInputPage
                                country={inputvalue.country_isocode}
                                value={phoneinput}
                                enableSearch={true}
                                className={"countrylist"}
                                onChange={countryChange}
                              />
                              <div className="text-danger">
                                {t(errorMsg.country_code)}
                                {t(errorMsg.mobile)}
                              </div>
                            </div>
                            <FormgroupPage
                              className="form-group"
                              label={''}
                              placeholder={t("pages.signup.emailId")}
                              name={"email"}
                              value={inputvalue.email}
                              onChange={(e) => inputValuechange(e)}
                              type="text"
                              error={t(errorMsg.email)}
                              require={false}
                            />
                            <InputGroup>
                              <FormControl
                                value={inputvalue.password}
                                name={"password"}
                                className="password-form-control"
                                placeholder={t("pages.signup.password_place")}
                                type={passwordState ? "text" : "password"}
                                onChange={(e) => inputValuechange(e)}
                              />
                              <InputGroup.Text
                                onClick={() => setPasswordState(!passwordState)}
                              >
                                <img
                                  src={passwordState ? EYE : EYE_OFF}
                                  height="20"
                                  width="20"
                                  alt="show"
                                ></img>
                              </InputGroup.Text>
                            </InputGroup>
                            <span className="text-danger">
                              {t(errorMsg.password)}
                            </span>
                            <ButtonPage
                              className="button-submit w-100 mt-3 mb-3"
                              onClick={(e) =>
                                !loader ? onSignUp(e) : e.preventDefault()
                              }
                              Text= {
                                <React.Fragment>
                                  {loader ? (
                                    <Spinner animation="border" />
                                  ) : (
                                    t("pages.signup.title")
                                  )}
                                </React.Fragment>
                              }
                            />
                          </div>

                          <div className="loginque text-center">
                            <h6>
                              {t("pages.signup.haveaccount")}
                              <span onClick={() => redirectTologin()}>
                                {t("pages.signup.login")}
                              </span>
                            </h6>
                          </div>
                        </Form>
                      ) : (
                        <OtpPage
                          showotp={showotp}
                          inputvalue={inputvalue}
                          setShowotp={setShowotp}
                          setpage_from={setpage_from}
                          page_from={page_from}
                          setMobileexist={setMobileexist}
                          mobileexist={mobileexist}
                        ></OtpPage>
                      )}
                    </div>
                  </Row>
                </div>
              </div>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  type: state?.login?.type,
  cartdata: state?.home?.cartdata,
  language: state?.languageState?.language,
  currentLocation: state?.home?.currentLocation,
});

export default connect(mapStateToProps, { fetchLogindata, fetchHeaderContent,maintainCartdata })(
  SignupPage
);
